import React from 'react';

const Icon = ({ size = '40', fill = 'url(#prefix_dxc-svg-to-react_c)', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path d="M35 12.083a1.25 1.25 0 0 1 0 2.5H5a1.25 1.25 0 1 1 0-2.5h30Z" fill="url(#a)" />

            <path
                d="M15.605 25.622a1.25 1.25 0 0 0 1.781-1.756l-1.063-1.078h6.947a2.148 2.148 0 0 1 0 4.295H20a1.25 1.25 0 0 0 0 2.5h3.27a4.647 4.647 0 0 0 0-9.295h-6.947l1.063-1.077a1.25 1.25 0 0 0-1.78-1.755l-3.163 3.205a1.25 1.25 0 0 0 0 1.756l3.162 3.205Z"
                fill="url(#b)"
            />

            <path
                d="m33.75 13.758-.005-.005a23.375 23.375 0 0 0-.66-.7 99.82 99.82 0 0 0-2.01-1.99 149.56 149.56 0 0 0-2.06-1.956 53.96 53.96 0 0 0-.732-.671c-.22-.197-.293-.253-.272-.24a1.567 1.567 0 0 0-.65-.261l-.222-.018H12.86l-.223.018a1.563 1.563 0 0 0-.647.262c-.015.013-.097.08-.274.239-.19.17-.44.399-.732.67a145.35 145.35 0 0 0-2.06 1.957 99.967 99.967 0 0 0-2.01 1.99 23.47 23.47 0 0 0-.66.7l-.005.005V30l.01.22c.045.506.247.965.548 1.3.341.379.773.563 1.192.563h24c.42 0 .851-.184 1.192-.563A2.28 2.28 0 0 0 33.75 30V13.758Zm2.48 16.681a4.748 4.748 0 0 1-1.18 2.754c-.784.872-1.878 1.39-3.05 1.39H8c-1.172 0-2.266-.518-3.05-1.39-.78-.867-1.2-2.017-1.2-3.193V13.333c0-.175.037-.35.109-.51.085-.191.211-.352.264-.419.076-.098.169-.204.265-.312.195-.219.45-.487.736-.782.575-.59 1.318-1.324 2.062-2.044a152.91 152.91 0 0 1 2.096-1.99c.299-.278.564-.52.77-.705.175-.157.38-.337.52-.433a4.033 4.033 0 0 1 2.288-.721h14.28l.306.011c.71.056 1.391.302 1.983.71.139.096.344.276.519.433.206.184.471.427.77.704.598.557 1.351 1.27 2.096 1.991.744.72 1.487 1.453 2.062 2.044.287.295.541.563.736.782.096.108.187.214.264.312.052.067.18.227.265.418.072.16.109.336.109.511V30l-.02.44Z"
                fill="url(#c)"
            />

            <defs>
                <linearGradient id="a" x1="33.43" y1="41.206" x2="-2.192" y2="40.337" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
                <linearGradient id="b" x1="33.43" y1="41.206" x2="-2.192" y2="40.337" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
                <linearGradient id="c" x1="33.43" y1="41.206" x2="-2.192" y2="40.337" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
